var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseModel from './BaseModel';
var OptionChoiceModel = /** @class */ (function (_super) {
    __extends(OptionChoiceModel, _super);
    function OptionChoiceModel(data, parentId) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.id = hydrated.id;
        _this.parentId = hydrated.parentId || parentId;
        _this.name = hydrated.name;
        _this.required = hydrated.required;
        _this.excluded = hydrated.excluded;
        _this.disabled = false;
        _this.receiptName = hydrated.receiptName;
        _this.description = hydrated.description;
        _this.searchTerms = hydrated.searchTerms;
        _this.selected = hydrated.selected;
        _this.priceDelta = hydrated.priceDelta;
        _this.ingredient = hydrated.ingredient;
        _this.mutableQuantity = hydrated.mutableQuantity;
        _this.maxQuantity = hydrated.maxQuantity;
        _this.quantity = hydrated.quantity;
        _this.ignoreCheckmark = hydrated.ignoreCheckmark;
        _this.maxFractionalQuantity = hydrated.maxFractionalQuantity;
        _this.fractionalQuantity = hydrated.fractionalQuantity;
        _this.includedQuantity = hydrated.includedQuantity;
        _this.isUserSet = hydrated.isUserSet;
        _this.images = hydrated.images;
        _this.basePriceDelta = hydrated.basePriceDelta;
        _this.__mc = 'OptionChoiceModel';
        return _this;
    }
    OptionChoiceModel.prototype.combineExceptionChoice = function (exceptionChoice) {
        if (this.id === exceptionChoice.ocid) {
            this.includedQuantity = +exceptionChoice.includedQuantity;
        }
        return this;
    };
    OptionChoiceModel.prototype.hydrate = function (data) {
        var choice = {};
        choice['id'] = "" + data.choice_id;
        choice['name'] = data.name;
        choice['required'] = data.required || false;
        choice['excluded'] = data.excluded || false;
        choice['receiptName'] = data.receipt_name;
        choice['description'] = data.description;
        choice['searchTerms'] = data.search_terms;
        choice['quantity'] = parseInt(data.qty);
        choice['selected'] = (data.selected) ? true : false;
        choice['priceDelta'] = parseInt(data.price_delta);
        choice['ingredient'] = data.ingredient;
        choice['mutableQuantity'] = data.mutable_qty ? true : false;
        choice['maxQuantity'] = parseInt(data.max_qty) || 100;
        choice['ignoreCheckmark'] = data.ignoreCheckmark ? true : false;
        choice['maxFractionalQuantity'] = parseInt(data.max_fractional_qty);
        choice['fractionalQuantity'] = parseInt(data.fractional_qty);
        choice['includedQuantity'] = +(data.included_qty);
        choice['images'] = data.images || null;
        choice['basePriceDelta'] = +(data.base_price_delta) || 0;
        choice['isUserSet'] = data.is_user_set || false;
        return choice;
    };
    // TODO hydrators could be taken out of model classes
    OptionChoiceModel.prototype.hydrateFromStore = function (data) {
        var choice = {};
        choice = data;
        return choice;
    };
    OptionChoiceModel.prototype.restore = function (data) {
        var choice = {};
        choice['id'] = "" + data.choice_id;
        choice['name'] = data.name;
        choice['includedQuantity'] = data.included_qty;
        choice['isUserSet'] = data.is_user_set || false;
        choice['fractionalQuantity'] = parseInt(data.fractional_qty);
        choice['maxFractionalQuantity'] = data.max_fractional_qty;
        choice['mutableQuantity'] = data.mutable_qty ? true : false;
        choice['maxQuantity'] = parseInt(data.max_qty);
        choice['priceDelta'] = parseInt(data.price_delta);
        choice['selected'] = data.selected;
        choice['required'] = data.required || false;
        choice['quantity'] = +data.qty;
        choice['images'] = data.images || null;
        return choice;
    };
    return OptionChoiceModel;
}(BaseModel));
export default OptionChoiceModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/OptionChoiceModel.ts
// module id = 6EO2
// module chunks = 18